import { ChangeDetectorRef, Component, OnInit, OnDestroy, ViewChild, LOCALE_ID } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { AuthService } from '../services/auth.service';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { PaymentBookingComponent } from './payment-booking/payment-booking.component';
import momentTz from 'moment-timezone'
import moment from 'moment';
import { ActivateLoadingAction, DeactivateLoadingAction } from '../redux/ui.actions';
import { MatCalendar, MatCalendarCellClassFunction, MatDatepicker } from '@angular/material/datepicker';
import { PdfModalComponent } from '../home/pdf-modal/pdf-modal.component';
import { AddCardComponent } from '../settings/add-card/add-card.component';
import {  MAT_DATE_LOCALE } from '@angular/material/core';
import { catchError, finalize, forkJoin, map, Observable, of, Subscription } from 'rxjs';

declare var OpenPay: any

@Component({
    selector: 'app-new-booking',
    templateUrl: './new-booking.component.html',
    styleUrls: ['./new-booking.component.scss'],
    providers: [{ provide: LOCALE_ID, useValue: 'es-ES' }, { provide: MAT_DATE_LOCALE, useValue: 'es-ES' }],
    standalone: false
})
export class NewBookingComponent implements OnInit, OnDestroy {
  @ViewChild('picker2') picker2: MatDatepicker<Date>;

  timeLabel = "Seleccione una hora";
  time_zone = "";
  Today;
  planId = "no_plan";

  doctorId = "";
  doctorCatId = "";
  minDate = new Date();
  doctorTimeSlots = [];
  doctorDate = "";
  doctorTime = "";
  doctorFee = 0;
  cupon = "";
  cuponText = "";
  cuponValid = false;
  couponApplying = false;
  totalFee = 0;
  promo = 0;
  dateSelected = false;
  descuento = 0;
  creditValid = false;
  extra_nombre="";
  extra_apellido="";
  totalDates = 0;
  reviewsList = [];
  averageReviews = 0;
  totalReviews = 0;
  dateString = ''
  doctorLoading = true;
  doctorLoadError = '';
  optionalDataWarning = '';
  private optionalDataWarningShown = false;
  loadingTimeSlots = false;
  calendarAvailabilityLoading = false;
  private timeSlotRequestId = 0;
  private readonly bookingLeadMinutes = 120;

  validatedCoupon = false

  doctor = {
    account_status: "blocked",
    birth_at: 750492000000,
    city: "",
    country: "MX",
    country_code: "+52",
    country_code_flag: "",
    created_at: 1588688193873,
    deleted: false,
    email: "Cargando...",
    email_verified_at: 0,
    first_name: "Cargando...",
    gender: "Male",
    id: 5,
    last_name: "",
    phone: "Cargando...",
    photo_media_id: { url: "http://api.mindhelp.dev/a37d8de0-c122-454b-82e4-df8a480ba9af-1588688385455.png" },
    resume_media_id: { url: "http://api.mindhelp.dev/1656ae56-3d4f-4c13-af6b-63af26501f3d-1588688384869.pdf" },
    roles: [],
    services: [{ name: "", cost: 0 }],
    state: "",
    street_address: "",
    time_slots: [],
    time_zone: "America/Mexico_City",
    updated_at: 1589221054645,
    user_description: "todo bien",
    user_description_short: "",
    working_since:0,
    zip: ""
  }

  showExtras=false;
  calendarDays = [];
  availableDays = new Set<string>();
  currentCalendarMonth = moment().format('YYYY-MM');
  private calendarMonthWatcher?: Subscription;
  private calendarMonthPoller?: ReturnType<typeof setInterval>;
  private requestedAvailabilityMonths = new Set<string>();
  private availabilityRequestsInFlight = new Set<string>();

  // calendar
  selectedDate = moment();

  //@ViewChild('calendar', { static: true })
  //calendar: MatCalendar<moment.Moment>;
  isDatePicker = false;
  currentMonth = moment().format('MM/DD/YYYY');
  onlyMonth = moment().format('MMMM');

  minDateLimit: Date;

  constructor(
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private service: AuthService,
    private router: Router,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    ) {
      this.setMinDate();
     }

  ngOnInit() {
    this.store.dispatch(new DeactivateLoadingAction());
    moment.locale('es');
    this.checkPromoCode();
    this.getUsesUser();
    this.getCurrentSuscription();
    // agarrar el time zone
    var resolvedOptions = Intl.DateTimeFormat().resolvedOptions()
    this.time_zone = resolvedOptions.timeZone;
    let date = new Date().getTime();

    this.doctorId = this.route.snapshot.paramMap.get("id");
    this.doctorCatId = this.route.snapshot.paramMap.get("cat_id");
    this.resetAvailabilityCache();
    const navigationDoctor = history.state && history.state.doctor;
    if (navigationDoctor && Number(navigationDoctor.id) === Number(this.doctorId)) {
      this.setDoctor(navigationDoctor);
      this.doctorLoading = false;
    }
    this.getDoctorDetail(this.doctorId);
    this.getReviews();
    this.getTimeSlots();
  }

  setMinDate() {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    this.minDateLimit = hoy;
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.calendarMonthWatcher?.unsubscribe();
    this.clearCalendarMonthPoller();
  }
  /*
  ngDoCheck(): void {
    let c: any = this.calendar;
    let currentMonth = moment(c._clampedActiveDate).format('MM/DD/YYYY');
    if (this.currentMonth != currentMonth) {
      this.onlyMonth = moment(c._clampedActiveDate).format('MMMM');
      console.log(currentMonth, this.currentMonth);
      this.currentMonth = currentMonth;
      this.getTimeSlots();
      //this.highlightDays(this.calendarDays);
      this.isDatePicker = false;
      this.dateSelected = false;
      this.doctorFee = 0;
      this.getDoctorDetail(this.doctorId);
    }
  }
*/
  dateClass: MatCalendarCellClassFunction<Date> = (date: Date) => {
    const dayKey = moment(date).format('YYYY-MM-DD');

    if (moment(date).isBefore(this.minDateLimit, 'day')) {
      return '';
    }

    if (this.availableDays.has(dayKey)) {
      return 'calendar-day-available';
    }

    if (moment(date).format('YYYY-MM') === this.currentCalendarMonth) {
      return 'calendar-day-unavailable';
    }

    return '';
  };

  onCalendarOpened(): void {
    setTimeout(() => {
      const calendar = this.getPopupCalendar();

      this.calendarMonthWatcher?.unsubscribe();
      if (calendar) {
        this.syncCalendarMonth(calendar.activeDate);
        this.calendarMonthWatcher = calendar.stateChanges.subscribe(() => {
          this.syncCalendarMonth(calendar.activeDate);
          this.syncVisibleCalendarLabelMonth();
          this.scheduleCalendarDomRepaint();
        });
      }

      this.syncVisibleCalendarLabelMonth();
      this.scheduleCalendarDomRepaint();
      this.clearCalendarMonthPoller();
      this.calendarMonthPoller = setInterval(() => {
        const activeCalendar = this.getPopupCalendar();
        if (activeCalendar) {
          this.syncCalendarMonth(activeCalendar.activeDate);
        }
        this.syncVisibleCalendarLabelMonth();
        this.scheduleCalendarDomRepaint();
      }, 250);
    });
  }

  onCalendarClosed(): void {
    this.calendarMonthWatcher?.unsubscribe();
    this.clearCalendarMonthPoller();
  }

  onCalendarMonthSelected(date: Date | moment.Moment): void {
    const activeDate = moment.isMoment(date) ? date.toDate() : date;
    this.syncCalendarMonth(activeDate);
  }

  private getPopupCalendar(): MatCalendar<Date> | null {
    const popupCalendar = (this.picker2 as any)?._popupComponentRef?.instance?._calendar;
    return popupCalendar || null;
  }

  private clearCalendarMonthPoller(): void {
    if (this.calendarMonthPoller) {
      clearInterval(this.calendarMonthPoller);
      this.calendarMonthPoller = undefined;
    }
  }

  private syncCalendarMonth(activeDate: Date): void {
    const visibleMonth = moment(activeDate).format('YYYY-MM');
    if (visibleMonth === this.currentCalendarMonth) {
      return;
    }

    this.currentCalendarMonth = visibleMonth;
    this.currentMonth = moment(activeDate).startOf('month').format('MM/DD/YYYY');
    this.isDatePicker = false;
    this.dateSelected = false;
    this.doctorFee = 0;
    this.doctorTimeSlots = [];
    this.getTimeSlots(activeDate);
  }

  private syncVisibleCalendarLabelMonth(): void {
    const visibleMonth = this.getVisibleCalendarMonthFromDom();
    if (!visibleMonth) {
      return;
    }

    this.syncCalendarMonth(visibleMonth.toDate());
  }

  private getVisibleCalendarMonthFromDom(): moment.Moment | null {
    const labelElement = document.querySelector('.mat-datepicker-content .mat-calendar-period-button');
    const label = labelElement?.textContent?.trim().toLowerCase();
    if (!label) {
      return null;
    }

    const match = label.match(/([a-záéíóúñ]+)\s+(\d{4})/i);
    if (!match) {
      return null;
    }

    const monthMap = {
      ene: 0, enero: 0, jan: 0, january: 0,
      feb: 1, febrero: 1, february: 1,
      mar: 2, marzo: 2, march: 2,
      abr: 3, abril: 3, apr: 3, april: 3,
      may: 4, mayo: 4,
      jun: 5, junio: 5, june: 5,
      jul: 6, julio: 6, july: 6,
      ago: 7, agosto: 7, aug: 7, august: 7,
      sep: 8, sept: 8, septiembre: 8, september: 8,
      oct: 9, octubre: 9, october: 9,
      nov: 10, noviembre: 10, november: 10,
      dic: 11, diciembre: 11, dec: 11, december: 11,
    };

    const monthIndex = monthMap[match[1]];
    const year = Number(match[2]);
    if (monthIndex === undefined || !Number.isFinite(year)) {
      return null;
    }

    return moment({ year, month: monthIndex, day: 1 });
  }

  private resetAvailabilityCache(): void {
    this.calendarDays = [];
    this.availableDays = new Set();
    this.requestedAvailabilityMonths = new Set();
    this.availabilityRequestsInFlight = new Set();
    this.calendarAvailabilityLoading = false;
  }

  private warnOptionalUserDataIssue(err: any): void {
    const message = this.service.getRequestErrorMessage(
      err,
      'No pudimos cargar algunos datos adicionales de tu cuenta en este servidor de pruebas.'
    );

    console.warn('Dato opcional no disponible:', message, err);
  }

  private isNom035User(): boolean {
    const user = this.service.user || {};
    const companyId = Number(user.company_id);
    const isNom035 = user.nom_035 === true || user.nom_035 === 1 || user.nom_035 === 'true' || user.nom_035 === '1';
    const isGnp = user.gnp === true || user.gnp === 1 || user.gnp === 'true' || user.gnp === '1';

    return companyId === 2 && isNom035 && !isGnp;
  }

  private applyNom035BookingFields(data: any): any {
    if (!this.isNom035User()) return data;

    return {
      ...data,
      promo_code: data.promo_code || 'NOM035',
      source: 'nom35',
    };
  }

  checkPromoCode(){
    let user = this.service.user;
    console.log(user)
    if(!user || !user.id) return;
    /*
    if( user.free_promo_code ){
      console.log('USUARIO',user);
      this.cupon = user.free_promo_code.code;
    } else {*/
      console.log('Buscando promo code')
      this.service.getUnusedPromoCodes(user.id).subscribe((data:any) => {
        try {
          let decData = this.service.parseEncryptedResponse(data, 'private');
          console.log('CODIGO', decData)

          if(decData?.data?.items?.length > 0){
            this.cupon = decData.data.items[0].code
          }
        } catch (err) {
          console.warn('No se pudo interpretar el cupón automático.', err);
          this.cupon = "";
        }
      }, err => {
        this.cupon = "";
        this.store.dispatch(new DeactivateLoadingAction());
        this.warnOptionalUserDataIssue(err);
        this.service.handleRequestError(err, {
          showModal: false,
          fallback: 'No se pudo cargar el cupón automático.'
        });
      })
    //}
  }

  getTimeSlots(monthRef: Date | string | moment.Moment = this.currentMonth, showLoading = true) {
    const month = moment(monthRef).startOf('month');
    const monthKey = month.format('YYYY-MM');

    if (this.requestedAvailabilityMonths.has(monthKey) || this.availabilityRequestsInFlight.has(monthKey)) {
      this.refreshCalendarView();
      return;
    }

    this.availabilityRequestsInFlight.add(monthKey);
    this.updateCalendarAvailabilityLoading();
    if (showLoading) {
      this.store.dispatch(new ActivateLoadingAction());
    }

    let day = month.valueOf().toString();
    let id = this.doctorId;
    console.log("Time slots", monthKey)

    this.service.getHours(id, day, 'month').subscribe((data: any) => {
      try {
        let decUser = this.service.parseEncryptedResponse(data, "public");
        const returnedDays = (decUser?.data?.items || [])
          .map((elem) => this.getAvailabilityDayMoment(elem))
          .filter((availableDay): availableDay is moment.Moment => !!availableDay)
          .map((availableDay) => availableDay.clone().startOf('day'));
        const returnedMonthKeys = Array.from(new Set(returnedDays.map((day) => day.format('YYYY-MM'))));
        const newDays = returnedDays.map((availableDay) => availableDay.format("MM/DD/YYYY"));

        if (returnedMonthKeys.length > 0 && !returnedMonthKeys.includes(monthKey)) {
          console.warn(
            `Disponibilidad solicitada para ${monthKey}, pero el backend respondió días de: ${returnedMonthKeys.join(', ')}.`,
            returnedDays.map((availableDay) => availableDay.format('YYYY-MM-DD'))
          );
        }

        console.log(`Disponibilidad ${monthKey}:`, newDays.length, newDays);

        this.calendarDays = Array.from(new Set([...this.calendarDays, ...newDays]));
        returnedDays
          .filter((day) => !day.isBefore(this.minDateLimit, 'day'))
          .forEach((day) => this.availableDays.add(day.format('YYYY-MM-DD')));

        this.requestedAvailabilityMonths.add(monthKey);
        this.refreshCalendarView();
      } catch (err) {
        console.error('No se pudo interpretar la disponibilidad del terapeuta.', err);
        this.refreshCalendarView();
        this.service.showRequestError(err, 'No pudimos cargar la disponibilidad del terapeuta. Intenta de nuevo en unos minutos.');
      } finally {
        this.availabilityRequestsInFlight.delete(monthKey);
        this.updateCalendarAvailabilityLoading();
        if (showLoading) {
          this.store.dispatch(new DeactivateLoadingAction());
        }
      }

    }, err => {
      this.availabilityRequestsInFlight.delete(monthKey);
      this.updateCalendarAvailabilityLoading();
      this.refreshCalendarView();
      this.service.handleRequestError(err, {
        deactivateLoading: showLoading,
        fallback: 'No pudimos cargar la disponibilidad del terapeuta. Intenta de nuevo en unos minutos.'
      });
    })
  }

  private updateCalendarAvailabilityLoading(): void {
    this.calendarAvailabilityLoading = this.availabilityRequestsInFlight.size > 0;
    this.refreshView();
  }

  private getAvailabilityDayMoment(item: any): moment.Moment | null {
    let rawDay = item?.day ?? item?.date ?? item?.start_at ?? item?.start_at_miliseconds_utc;

    if (!rawDay && Array.isArray(item?.availability) && item.availability.length > 0) {
      rawDay = item.availability[0]?.day
        ?? item.availability[0]?.date
        ?? item.availability[0]?.start_at
        ?? item.availability[0]?.start
        ?? item.availability[0]?.start_at_miliseconds_utc;
    }

    if (!rawDay) {
      return null;
    }

    if (typeof rawDay === 'number' || /^\d+$/.test(String(rawDay))) {
      const parsedTimestamp = moment(Number(rawDay));
      return parsedTimestamp.isValid() ? parsedTimestamp.startOf('day') : null;
    }

    const parsedDay = moment(rawDay);
    return parsedDay.isValid() ? parsedDay.startOf('day') : null;
  }

  getDoctorDetail(doc_id) {
    this.doctorLoading = !this.hasLoadedDoctor();
    this.doctorLoadError = '';

    this.service.getDoctorDetail(doc_id, this.doctorCatId).subscribe((data: any) => {
      let decData;
      try {
        decData = this.service.parseEncryptedResponse(data,"public");
      } catch (err) {
        this.doctorLoading = false;
        this.doctorLoadError = 'No pudimos cargar la información del terapeuta. Intenta regresar y seleccionar otro terapeuta.';
        this.service.showRequestError(err, 'No pudimos cargar la información del terapeuta. Intenta elegir otro terapeuta.');
        return;
      }
      const doctorItems = decData?.data?.items || [];

      if(!Array.isArray(doctorItems) || doctorItems.length === 0){
        this.doctorLoading = false;
        if (!this.hasLoadedDoctor()) {
          this.doctorLoadError = 'No pudimos cargar la información del terapeuta. Regresa e intenta seleccionarlo de nuevo.';
        }
        return;
      }

      this.setDoctor(doctorItems[0]);
      this.doctorLoading = false;
      this.doctorLoadError = '';
      this.refreshView();
    }, err => {
      this.doctorLoading = false;
      if (!this.hasLoadedDoctor()) {
        this.doctorLoadError = 'No pudimos cargar la información del terapeuta. Intenta regresar y seleccionar otro terapeuta.';
      }
      this.service.handleRequestError(err, {
        showModal: !this.hasLoadedDoctor(),
        fallback: 'No pudimos cargar la información del terapeuta. Intenta elegir otro terapeuta.'
      });
      // this.presentAlert(err.error.msg);
    })
  }

  private setDoctor(doctorData): void {
    this.doctor = doctorData;
    this.totalReviews = this.getReviewCountFromDoctor(doctorData);
    console.log('DOCTOR', doctorData)
    this.totalDates = (doctorData.time_slots || []).filter(obj =>{
      if(obj.slot_type ==='availability') return true;
      return false;
    }).length;
    this.refreshView();
  }

  private hasLoadedDoctor(): boolean {
    return !!this.doctor && Number(this.doctor.id) === Number(this.doctorId) && this.doctor.first_name !== 'Cargando...';
  }

  private getReviewCountFromDoctor(doctorData): number {
    const rawCount = doctorData?.total_reviews
      ?? doctorData?.total_review
      ?? doctorData?.totalReviews
      ?? doctorData?.reviewsTotal
      ?? doctorData?.reviews_total
      ?? doctorData?.reviews_count
      ?? doctorData?.reviewsCount
      ?? doctorData?.review_count
      ?? doctorData?.reviewCount
      ?? doctorData?.rating_count
      ?? doctorData?.ratings_count
      ?? doctorData?.reviews?.length
      ?? 0;
    const count = Number(rawCount);

    return Number.isFinite(count) && count > 0 ? count : 0;
  }

  getVisibleReviewCount(): number {
    return this.reviewsList.length > 0 ? this.reviewsList.length : this.totalReviews;
  }

  getVisibleReviewLabel(): string {
    const count = this.getVisibleReviewCount();
    return `${count} ${count === 1 ? 'Reseña' : 'Reseñas'}`;
  }

  dateChanged() {
    console.log(this.selectedDate)
    console.log("date change", this.selectedDate.format)
    this.isDatePicker = true;
    this.dateSelected = false;
    this.getDate(this.selectedDate);
    this.dateString = moment(this.selectedDate).format('DD-MM-YYYY')
  }

  handleDateChange(selectedDate: any): void {
    this.selectedDate = selectedDate.value
    console.log("date change", this.selectedDate.format)
    this.isDatePicker = true;
    this.resetSelectedTimeState('Cargando horarios...');
    this.getDate(this.selectedDate);
    this.dateString = moment(this.selectedDate).format('DD-MM-YYYY')
    console.log(this.dateString)
  }

  getDate(date) {
    const requestId = ++this.timeSlotRequestId;
    this.loadingTimeSlots = true;
    this.resetSelectedTimeState('Cargando horarios...');

    const selectedDay = moment(date).set({
      hour: moment().hour(),
      minute: moment().minute(),
      second: 0,
      millisecond: 0
    });

    this.doctorDate = selectedDay.format('MM/DD/YYYY');

    forkJoin({
      primary: this.loadDoctorSlots(this.service.getDoctorTimeList(this.doctorId, selectedDay.valueOf()), requestId),
      secondary: this.loadDoctorSlots(this.service.getDoctorTimeListOtherApi(this.doctorId, selectedDay.valueOf()), requestId)
    }).subscribe(({ primary, secondary }) => {
      if (requestId !== this.timeSlotRequestId) return;

      const primarySlots = this.buildBookableTimeOptions(primary, selectedDay);
      const secondarySlots = this.buildBookableTimeOptions(secondary, selectedDay);
      let availableSlots = primarySlots;

      if (primarySlots.length > 0 && secondarySlots.length > 0) {
        availableSlots = this.intersectTimeOptions(primarySlots, secondarySlots);
      } else if (primarySlots.length === 0 && secondarySlots.length > 0) {
        availableSlots = secondarySlots;
      }

      this.finishTimeSlotLoad(availableSlots, requestId);
    }, err => {
        this.finishTimeSlotLoad([], requestId);
        this.service.handleRequestError(err, {
          fallback: 'No pudimos consultar los horarios disponibles. Intenta elegir otra fecha.'
        });
    });
  }

  private loadDoctorSlots(request$: Observable<any>, requestId: number): Observable<any[]> {
    return request$.pipe(
      map((response: any) => {
        if (requestId !== this.timeSlotRequestId) return [];

        const decData = this.service.parseEncryptedResponse(response, "public");
        return this.formatSlots(decData?.data?.items || []);
      }),
      catchError((err) => {
        if (requestId === this.timeSlotRequestId) {
          console.warn('No se pudieron leer horarios de una fuente, se usara la otra si trae datos.', err);
        }

        return of([]);
      })
    );
  }

  private buildBookableTimeOptions(slots: any[], selectedDay: moment.Moment): any[] {
    return slots
      .filter(slot => slot.slot_type === 'availability' && this.isBookableSlot(slot.start, selectedDay))
      .map(slot => ({
        start: moment(slot.start).format('HH:mm'),
        start_hour: moment(slot.start).format('h:mm a'),
        slot_type: slot.slot_type
      }))
      .sort((a, b) => a.start.localeCompare(b.start));
  }

  private intersectTimeOptions(primarySlots: any[], secondarySlots: any[]): any[] {
    return primarySlots.filter(slot => {
      return secondarySlots.some(secondary => {
        return secondary.start === slot.start && secondary.slot_type === slot.slot_type;
      });
    });
  }

  private isBookableSlot(slotStart: any, selectedDay: moment.Moment): boolean {
    const slotMoment = moment(slotStart);

    if (!slotMoment.isValid() || !slotMoment.isSame(selectedDay, 'day')) {
      return false;
    }

    if (slotMoment.isBefore(moment(this.minDateLimit), 'day')) {
      return false;
    }

    if (slotMoment.isSame(moment(), 'day')) {
      return slotMoment.isSameOrAfter(this.getMinimumBookableMoment());
    }

    return true;
  }

  private getMinimumBookableMoment(): moment.Moment {
    return moment().add(this.bookingLeadMinutes, 'minutes');
  }

  getMinimumTodayBookingTimeLabel(): string {
    return this.getMinimumBookableMoment().format('h:mm a');
  }

  private getSelectedStartMoment(): moment.Moment | null {
    if (!this.doctorDate || !this.doctorTime) return null;

    const selected = momentTz.tz(
      `${this.doctorDate} ${this.doctorTime}:00`,
      'MM/DD/YYYY HH:mm:ss',
      this.time_zone
    );

    return selected.isValid() ? selected : null;
  }

  private isSelectedTimeBookable(): boolean {
    const selectedStart = this.getSelectedStartMoment();
    if (!selectedStart) return false;

    if (selectedStart.isBefore(moment(this.minDateLimit), 'day')) {
      return false;
    }

    if (selectedStart.isSame(moment(), 'day')) {
      return selectedStart.isSameOrAfter(this.getMinimumBookableMoment());
    }

    return true;
  }

  private validateSelectedTimeBeforeBooking(): boolean {
    if (this.isSelectedTimeBookable()) return true;

    Swal.fire({
      icon: 'warning',
      title: 'Selecciona otro horario',
      text: `Para agendar una cita de hoy necesitas al menos 2 horas de anticipación. El horario disponible debe ser desde las ${this.getMinimumTodayBookingTimeLabel()}.`,
      showConfirmButton: true,
      confirmButtonText: 'ok',
      confirmButtonColor: '#023171',
    });

    this.doctorTime = '';
    this.dateSelected = false;
    this.doctorFee = 0;
    this.totalFee = 0;
    return false;
  }

  private resetSelectedTimeState(label = 'Horarios disponibles'): void {
    this.doctorTimeSlots = [];
    this.doctorTime = '';
    this.doctorFee = 0;
    this.totalFee = 0;
    this.dateSelected = false;
    this.cuponValid = false;
    this.validatedCoupon = false;
    this.timeLabel = label;
  }

  private finishTimeSlotLoad(slots: any[], requestId: number): void {
    if (requestId !== this.timeSlotRequestId) return;

    this.doctorTimeSlots = slots;
    this.doctorTime = '';
    this.doctorFee = 0;
    this.totalFee = 0;
    this.dateSelected = false;
    this.loadingTimeSlots = false;
    this.timeLabel = slots.length === 0 ? this.getEmptyTimeLabel() : 'Seleccione una hora';
    this.refreshView();
  }

  private getEmptyTimeLabel(): string {
    const selectedDay = this.doctorDate ? moment(this.doctorDate, 'MM/DD/YYYY') : null;

    if (selectedDay?.isValid() && selectedDay.isSame(moment(), 'day')) {
      return 'Sin horarios con 2 h de anticipación';
    }

    return 'No hay horas disponibles';
  }

  compareNumbers(a, b) {
    return a - b;
  }

  monthChanged($event) {
    console.log($event);
  }

  formatSlots(slots){
    let newTimesS = [];
    slots.forEach(element => {
      // get the day of the mont
      let date = moment.utc(element.day ).format('MMM/DD/YYYY');

      // get the times in the day of the mont
      let newTimes = element.availability.map(elem => {

        let start = moment(elem.start_at_miliseconds_utc).format();
        let plushour = moment(elem.start_at_miliseconds_utc).add(1,'hour').format();

        let end =  moment(plushour).format()

        return {
          start: new Date(start),
          minutes: elem.minutes,
          slot_type: elem.slot_type
        }
      })

      newTimesS = newTimesS.concat(newTimes)

    });
    return newTimesS
  }

  getTime(time) {
    console.log(time);
    this.doctorTime = time;
    if (!this.isSelectedTimeBookable()) {
      this.validateSelectedTimeBeforeBooking();
      return;
    }
    this.getFee();
  }

  canBook(): boolean {
    return !!this.doctorTime
      && this.dateSelected
      && this.isSelectedTimeBookable()
      && this.cuponValid
      && this.totalFee <= 0
      && !this.couponApplying
      && !this.loadingTimeSlots
      && !this.doctorLoading
      && !this.doctorLoadError;
  }

  canApplyCoupon(): boolean {
    return !!this.cupon?.trim()
      && !this.cuponValid
      && !this.couponApplying
      && this.doctorFee > 0;
  }

  onCouponInputChange(value: string): void {
    this.cupon = value;
    this.cuponText = "";
    this.cuponValid = false;
    this.validatedCoupon = false;
    this.promo = 0;
    this.descuento = 0;
    this.totalFee = this.doctorFee;
  }

  getMoney(doctorFee:number){
    return doctorFee + '.00 MXN'
  }

  getFee() {
    console.log('COSTO', this.doctor.services[0].cost)
    this.doctorFee = this.doctor.services[0].cost;
    this.totalFee = this.doctorFee;
    this.dateSelected = true;
    if (this.cupon) {
      this.applyCupon();
    }
  }

  applyCupon() {
    this.cuponText = "";
    this.totalFee = this.doctorFee;

    if (!this.cupon?.trim()) {
      this.cuponValid = false;
      this.validatedCoupon = false;
      this.cuponText = "Ingresa un cupón para poder agendar.";
      return;
    }

    let data = {
      code: this.cupon.trim(),
    }

    this.couponApplying = true;
    this.service.applyCupon(data).pipe(
      finalize(() => {
        this.couponApplying = false;
        this.refreshView();
      })
    ).subscribe((d: any) => {
      let decData = this.service.parseEncryptedResponse(d,"private");

      console.log(decData.data.items[0])
      let data = decData.data.items[0]
      this.cuponValid = data.isValid;
      if(!this.cuponValid){
        this.resetCupon();
        this.cuponText = "El cupón no se puede aplicar.";
        this.totalFee = this.doctorFee;
        return;
      }
      this.cuponText = "Cupón aplicado";

      this.validatedCoupon = true

      if (data.flat_amount === 0) {
        this.promo = (this.totalFee * data.discount_percentage)
        this.descuento = (this.totalFee * data.discount_percentage)
      } else {
        this.promo = data.flat_amount;
        this.descuento = data.flat_amount;
      }

      console.log(this.promo)

      this.totalFee -= this.promo;

      console.log(this.totalFee)

    }, err => {
      this.service.handleRequestError(err, {
        fallback: 'No pudimos validar el cupón. Revisa el cupón o intenta más tarde.'
      });
      this.resetCupon();
      this.cuponText = "El cupón no es válido";
      this.cuponValid = false;
      this.totalFee = this.doctorFee;
    })

  }

  applyCredit(){
    this.service.getUsesUser().subscribe((res: any) =>{
      let encData = this.service.parseEncryptedResponse(res, 'private');
      if(encData.data.items.length > 0){
        this.service.user.max_uses = encData.data.items[0].max_uses;
        this.service.user.uses = encData.data.items[0].uses;
        this.service.user.uses--;
      }
    }, err => {
      this.service.handleRequestError(err, {
        showModal: false,
        fallback: 'No se pudieron cargar los créditos del usuario.'
      });
    });
    this.creditValid = true;
    this.totalFee = 0;
  }

  disapplyCredit(){
    this.service.getUsesUser().subscribe((res: any) =>{
      let encData = this.service.parseEncryptedResponse(res, 'private');
      if(encData.data.items.length > 0){
        this.service.user.max_uses = encData.data.items[0].max_uses;
        this.service.user.uses = encData.data.items[0].uses;
      }
    }, err => {
      this.service.handleRequestError(err, {
        showModal: false,
        fallback: 'No se pudieron cargar los créditos del usuario.'
      });
    });
    this.creditValid = false;
    this.totalFee = this.doctorFee;
  }

  saveBooking() {
    if (!this.validateSelectedTimeBeforeBooking()) {
      return;
    }

    if (!this.cuponValid || this.totalFee > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Cupón requerido',
        text: "Para agendar esta sesión necesitas ingresar y aplicar un cupón válido que cubra el total de la consulta.",
        showConfirmButton: true,
        confirmButtonText: "ok",
        confirmButtonColor:'#023171',
      });
      return
    }

    this.suscriptionBooking();

    // return;
    ////if( this.planId != "no_plan" && this.cuponValid ){
    ////this.suscriptionBooking();
    ////}else{
      ////this.openDialog();
    ////}
  }

  openDialog() {
    const dialogRef = this.dialog.open(PaymentBookingComponent, {
      width: '800px',
      height: '600px',
      data: { isSold: false, index: null },
    });

    dialogRef.componentInstance.dataEvent.subscribe((data) => {
      const dialogRefCard = this.dialog.open(AddCardComponent)
      dialogRefCard.afterClosed().subscribe(result => {
        console.log('RESULTADO',result)
        dialogRef.close(result)
      })
    })

    dialogRef.afterClosed().subscribe(result => {
      console.log('RESULT',result);
      this.executePayment(result)
    });
  }

  suscriptionBooking(){
    if (!this.validateSelectedTimeBeforeBooking()) {
      return;
    }

    const selectedStart = this.getSelectedStartMoment();
    if (!selectedStart) return;
    let start_at = selectedStart.clone().tz('UTC').format('x');
    console.log(start_at);

    ////let dateplus = moment(date).add(1,'hour').format('LLL');
    ////let end_at = momentTz(dateplus).tz('UTC').format('x');
    let end_at = selectedStart.clone().add(1,'hour').tz('UTC').format('x');

    let method = this.service.PAYMETHODS.cupon;

    var data = this.applyNom035BookingFields({
      start_at: parseInt(start_at),
      end_at: parseInt(end_at),
      doctor_user_id: Number(this.doctorId),
      patient_user_id: this.service.user.id,
      base_price: this.doctorFee,
      final_price: this.totalFee,
      review: 5,
      promo_code: this.cupon,
      index: 0,
      paymentmethod_id: method,
      extra_firstname: this.extra_nombre,
      extra_lastname: this.extra_apellido,
      device_session_id:"jjKQM458OJ37A9IrQoxnIUO647e0710h",
      card_token:"ko61eyepcskqsoywobkj"
    })

    if(!this.extra_nombre) delete data.extra_firstname;
    if(!this.extra_apellido) delete data.extra_lastname;

    console.log('CUERPO', data)
    this.service.saveBooking(data).subscribe((d: any) => {
      console.log(d)
      Swal.fire({
        icon: 'success',
        title: '¡Tu sesión ha sido agendada!',
        text: "Muy pronto recibirás confirmación de tu terapeuta",
        showConfirmButton: true,
        confirmButtonText: "ok",
        confirmButtonColor:'#023171',
      });
      this.router.navigate(['/panel/booking']);
    }, err => {
      this.service.handleRequestError(err, {
        fallback: 'No pudimos agendar la cita. Intenta de nuevo en unos minutos.'
      });
    });
  }

  getReviews(){
    this.service.getReviews(this.doctorId).subscribe( (d:any) =>{
      let decData = this.service.parseEncryptedResponse(d);
      this.reviewsList = decData.data.items || [];
      if (this.reviewsList.length > 0) {
        this.totalReviews = this.reviewsList.length;
      }
      this.averageReviews = 0;
      this.reviewsList.forEach(rev => {
        this.averageReviews += Number(rev.score || 0);
      });
      if(this.reviewsList.length > 0)
        this.averageReviews = Math.round(this.averageReviews/this.reviewsList.length);
      this.refreshView();
    }, err => {
      this.reviewsList = [];
      this.averageReviews = 0;
      this.refreshView();
      this.service.handleRequestError(err, {
        showModal: false,
        fallback: 'No se pudieron cargar las reseñas.'
      });
    })
  }

  private refreshCalendarView(): void {
    setTimeout(() => {
      const calendar = this.getPopupCalendar();
      if (calendar) {
        const activeDate = calendar.activeDate;
        calendar.updateTodaysDate();
        calendar.activeDate = new Date(activeDate.getTime());
      }
      this.refreshView();
      this.scheduleCalendarDomRepaint();
    });
  }

  private refreshView(): void {
    setTimeout(() => this.cdr.detectChanges());
  }

  private scheduleCalendarDomRepaint(): void {
    setTimeout(() => {
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(() => this.applyAvailabilityClassesToCalendarDom());
        return;
      }

      this.applyAvailabilityClassesToCalendarDom();
    });
  }

  private applyAvailabilityClassesToCalendarDom(): void {
    const visibleMonth = this.getVisibleCalendarMonthFromDom();
    if (!visibleMonth) {
      return;
    }

    this.currentCalendarMonth = visibleMonth.format('YYYY-MM');

    const cells = document.querySelectorAll('.mat-datepicker-content .mat-calendar-body-cell');
    cells.forEach((cell: Element) => {
      cell.classList.remove('calendar-day-available', 'calendar-day-unavailable');

      const content = cell.querySelector('.mat-calendar-body-cell-content');
      const label = content?.textContent?.trim();
      if (!label || !/^\d+$/.test(label)) {
        return;
      }

      const dayNumber = Number(label);
      if (!Number.isFinite(dayNumber) || dayNumber < 1 || dayNumber > 31) {
        return;
      }

      const cellDate = visibleMonth.clone().date(dayNumber);
      if (cellDate.month() !== visibleMonth.month() || cellDate.isBefore(this.minDateLimit, 'day')) {
        return;
      }

      const dayKey = cellDate.format('YYYY-MM-DD');
      cell.classList.add(this.availableDays.has(dayKey) ? 'calendar-day-available' : 'calendar-day-unavailable');
    });
  }

  getCurrentSuscription(){
    this.service.getCurrentSuscription().subscribe( (d:any) =>{
      try {
        let decData = this.service.parseEncryptedResponse(d, "private");
        console.log('DATOS:',decData?.data?.items?.[0]);
        let data = decData?.data?.items?.[0];

        if (!data) {
          this.planId = "no_plan";
          return;
        }

        this.planId = data?.plan?.conekta_id || "no_plan";
        this.cupon = data?.promo_code?.code || this.cupon;
      } catch (err) {
        console.warn('No se pudo interpretar la suscripción activa.', err);
        this.planId = "no_plan";
      } finally {
        this.store.dispatch(new DeactivateLoadingAction());
      }
    },err =>{
      this.store.dispatch(new DeactivateLoadingAction());
      this.warnOptionalUserDataIssue(err);
      this.service.handleRequestError(err, {
        showModal: false,
        fallback: 'No se encontró suscripción activa.'
      });
      this.planId = "no_plan";
    });
  }

  getUsesUser(){
    this.service.getUsesUser().subscribe((res: any) =>{
      try {
        let encData = this.service.parseEncryptedResponse(res, 'private');
        if(encData?.data?.items?.length > 0){
          this.service.user.max_uses = encData.data.items[0].max_uses;
          this.service.user.uses = encData.data.items[0].uses;
        }
      } catch (err) {
        console.warn('No se pudieron interpretar los usos disponibles.', err);
      } finally {
        this.store.dispatch(new DeactivateLoadingAction());
      }
    }, err => {
      this.store.dispatch(new DeactivateLoadingAction());
      this.warnOptionalUserDataIssue(err);
      this.service.handleRequestError(err, {
        showModal: false,
        fallback: 'No se pudieron cargar los usos disponibles.'
      });
    });
  }

  toogleExtras(){
    this.showExtras = !this.showExtras;
  }

  resetCupon(){
    setTimeout(function(){
      this.cuponText = "";
      this.cupon = "";
    },3000);
  }

  setDefaultPic(event){
    event.target.src = './assets/icono.png';
  }

  openPdfModal(link:string): void {
    const dialogRef = this.dialog.open(PdfModalComponent, {
      width: '88vw',
      height: '88vh',
      data: {
        pdfLink: link, // Reemplaza con tu enlace web del PDF
      },
    });
  }

  executePayment(result){
    if (result != undefined) {
      if (!this.validateSelectedTimeBeforeBooking()) {
        return;
      }

      const selectedStart = this.getSelectedStartMoment();
      if (!selectedStart) return;
      let start_at = selectedStart.clone().tz('UTC').format('x');
      let fechaLegible = new Date(parseInt(start_at, 10));

      fechaLegible.setHours(fechaLegible.getHours() + 1);
      let end_at = fechaLegible.getTime()

      let method = this.cuponValid ? this.service.PAYMETHODS.tarjetacupon:this.service.PAYMETHODS.tarjeta;
      // return;

      OpenPay.setId('m1coum5skcmrq6pku2yv');
    ​  OpenPay.setApiKey('pk_da9513e220b247fb931f10910924b216');
      //OpenPay.setSandboxMode(true)
      //OpenPay.setSandboxMode(false)

      var deviceDataId = OpenPay.deviceData.setup();

      let data = this.applyNom035BookingFields({
        start_at: start_at,
        end_at: end_at,
        doctor_user_id: Number(this.doctorId),
        patient_user_id: this.service.user.id,
        base_price: this.doctorFee,
        final_price: this.totalFee,
        //final_price:900,
        review: 5,
        promo_code: this.cupon,
        index: 0,
        paymentmethod_id: method,

        device_session_id:deviceDataId,
        card_token:result.id
      })
      console.log(data)

      //this.service.savePayedBooking(body).subscribe((d: any) => {
        this.service.saveBooking(data).subscribe((d: any) => {
          d = this.service.parseEncryptedResponse(d, 'public')
          console.log('RESPONSE',d)
          window.location.href = d.data.items[0].url;
          
        }, err => {
          this.service.handleRequestError(err, {
            fallback: 'No pudimos iniciar el pago. Intenta de nuevo o revisa tu método de pago.'
          });
        })
        /*
      }, err => {
        if(err.name === "HttpErrorResponse"){
          Swal.fire({
            title: 'Error de conexión',
            text: 'Intente de nuevo más tarde.',
            icon: 'error',
          });
        }
        let decUser = JSON.parse(this.service.decrypt(err.error.message, "private"));
        console.log('ERROR', decUser)
        Swal.fire({
          icon: 'error',
          title: 'Ha ocurrido un error',
          showConfirmButton: true,
          confirmButtonText: "ok",
          confirmButtonColor:'#023171',
          text: 'Ocurrió un error al realizar el pago. Intente de nuevo más tarde, o revise sus datos.'//err.error.error.errors[0].message,
        });
      });
      */
    }
  }

  formatDate(d){
    let date = new Date(d)
    return moment(date, "YYYYMMDD").fromNow(true);
  }

}
